/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Prompt_Low_ThanksInputs */

const en_rate_prompt_low_thanks = /** @type {(inputs: Rate_Prompt_Low_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for the feedback! We're working hard to make it better.`)
};

const es_rate_prompt_low_thanks = /** @type {(inputs: Rate_Prompt_Low_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por tu opinión! Estamos trabajando para mejorar.`)
};

/**
* | output |
* | --- |
* | "Thanks for the feedback! We're working hard to make it better." |
*
* @param {Rate_Prompt_Low_ThanksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const rate_prompt_low_thanks = /** @type {((inputs?: Rate_Prompt_Low_ThanksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Prompt_Low_ThanksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_rate_prompt_low_thanks(inputs)
	return en_rate_prompt_low_thanks(inputs)
});